import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'src/shared/components/tooltip'
import { twMerge } from 'tailwind-merge'

export interface ToggleProps
  extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'type' | 'onChange'
  > {
  label?: React.ReactNode
  skipTranslation?: boolean
  tooltipText?: string
  skipTranslationTooltip?: boolean
  wrapperClassName?: string
  labelClassName?: string
  onChange: (checked: boolean) => void
  startElement?: ReactNode
}

export const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  label,
  skipTranslation,
  tooltipText,
  skipTranslationTooltip,
  wrapperClassName = '',
  labelClassName,
  startElement,
  ...props
}) => {
  const { t } = useTranslation()

  return (
    <span
      id={props.id}
      className={`flex items-center gap-2 ${wrapperClassName}`}
    >
      <label
        className={twMerge(
          'relative flex cursor-pointer items-center gap-2 rounded-l-full',
          labelClassName,
        )}
      >
        {startElement}
        <span className="relative">
          <input
            type="checkbox"
            checked={checked}
            onChange={e => onChange(e.target.checked)}
            className={twMerge(
              `flex h-[19px] w-8 cursor-pointer appearance-none items-center rounded-full transition-colors duration-200 focus:outline-none disabled:bg-btnDisabled`,
              checked ? 'bg-primary-500' : 'bg-bgTertiary',
            )}
            {...props}
          />
          <span
            className={`absolute top-1 left-1 h-[11px] w-[11px] transform rounded-full bg-bgPrimaryBase transition-transform duration-200 ${checked ? 'translate-x-[13px]' : 'translate-x-0'} `}
          />
        </span>
        {label && (
          <span className="text-M">
            {!skipTranslation && typeof label === 'string' ? t(label) : label}
          </span>
        )}
      </label>
      {tooltipText && (
        <Tooltip
          message={tooltipText}
          skipTranslation={skipTranslationTooltip}
        />
      )}
    </span>
  )
}
